import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/oneOffCosts')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/oneOffCost' })
  },
})
